module.exports = __webpack_public_path__ + "static/media/IMG_3476_sm.cb9de506.jpg";